<template>
  <div class="bill-codes-container">
    <div class="codes-wrapper">
      <span v-if="codes.length > 0" class="clear-all" @click="clearAll">×</span>
      <div v-for="(code, index) in codes" :key="index" class="code-tag">
        <span class="code-text">{{ code }}</span>
        <span class="code-delete" @click="removeCode(index)">×</span>
      </div>
      <input
        ref="inputRef"
        v-model="inputValue"
        class="code-input"
        :placeholder="codes.length === 0 ? $lang('请输入单号，多编号使用逗号、空格或回车键隔开，最多100个') : ''"
        @keydown="handleKeydown"
        @blur="handleBlur"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import { getSiteCodes } from '@jms/utils'

  const emit = defineEmits(['update:value'])
  const props = defineProps<{ value: string[] }>()
  const inputRef = ref<HTMLInputElement>()
  const inputValue = ref('')
  const codes = ref<string[]>([...props.value])

  watch(
    () => props.value,
    (c) => {
      codes.value = [...c]
    }
  )

  const removeCode = (index: number) => {
    codes.value.splice(index, 1)
    emit('update:value', codes.value)
  }

  const clearAll = () => {
    codes.value = []
    emit('update:value', codes.value)
  }

  const handleKeydown = (e: KeyboardEvent) => {
    if (['Enter', ',', ' ', '，'].includes(e.key)) {
      e.preventDefault()
      addCode()
    } else if (e.key === 'Backspace' && inputValue.value === '' && codes.value.length > 0) {
      codes.value.pop()
      emit('update:value', codes.value)
    }
  }

  const handleBlur = () => {
    addCode()
  }

  const addCode = () => {
    const newCodes = getSiteCodes(inputValue.value).splice(0, 100 - codes.value.length)
    if (newCodes.length > 0) {
      codes.value.push(...newCodes)
      emit('update:value', codes.value)
    }
    inputValue.value = ''
  }
</script>
<style lang="less" scoped>
  .bill-codes-container {
    width: 100%;
  }
  .codes-wrapper {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 4px 30px 4px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    min-height: 32px;
    max-height: 68px;
    overflow-y: auto;
    background: #fff;
  }
  .codes-wrapper:focus-within {
    border-color: @primary-color;
    box-shadow: 0 0 0 2px rgba(@primary-color, 0.2);
  }
  .code-tag {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    background: #f5f5f5;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
  .code-text {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .code-delete {
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    color: #999;
  }
  .code-delete:hover {
    color: #e60032;
  }
  .clear-all {
    position: absolute;
    top: 4px;
    right: 8px;
    cursor: pointer;
    font-size: 12px;
    color: @primary-color;
  }
  .clear-all:hover {
    color: #40a9ff;
  }
  .code-input {
    flex: 1;
    min-width: 100px;
    border: none;
    outline: none;
    padding: 4px 0;
    font-size: 14px;
    background: transparent;
  }
</style>
